export const GET_OFFERS_REQUEST = 'GET_OFFERS_REQUEST';
export const GET_OFFERS_RESPONSE = 'GET_OFFERS_RESPONSE';
export const GET_OFFERS_SUCCESS = 'GET_OFFERS_SUCCESS';
